module.exports = __webpack_public_path__ + "img/manual-holiday-01-calendar.901983b8.png";